<ng-container *mobxAutorun>
  <ng-container *ngIf="shouldDisplay">
    <!-- Label -->
    <span *ngIf="label" class="label">{{ label }}</span>
    <lf-help-tooltip *ngIf="helpMessage" [help]="helpMessage"></lf-help-tooltip>

    <!-- Required icon -->
    <lf-icon
      class="is-required"
      icon="asterisk"
      *ngIf="showIsRequired && !isReadOnly"
    ></lf-icon>

    <!-- Pending validation -->
    <div
      class="status pending"
      *ngIf="relativeStorage.shouldShowPending()"
    ></div>
    <!-- Rejected validation -->
    <div
      class="status rejected"
      *ngIf="relativeStorage.shouldShowRejected()"
      (click)="relativeStorage.recomputeStateProperties()"
    >
      <lf-tooltip [help]="retryValidateText">
        <lf-icon icon="warning"></lf-icon>
      </lf-tooltip>
    </div>

    <!-- (Debug) value state -->
    <lf-value-state [path]="path"></lf-value-state>

    <!-- Input group -->
    <div
      class="input-group input-group-sm"
      [class.is-warning]="relativeStorage.shouldShowWarning()"
      [class.is-invalid]="relativeStorage.shouldShowError()"
    >
      <!-- Code -->
      <div *ngIf="code" class="input-group-prepend">
        <div class="input-group-text">{{ code }}</div>
      </div>

      <!-- Input -->
      <!--
        We disable the directive's `triggers` since it doesn't work well on
        focus (using "focus" as a trigger will cause the menu to disappear if it
        was already shown since the trigger calls `toggle`). Instead we manually
        call `show` on focus.
      -->
      <input
        #focusTarget
        bsDatepicker
        #dp="bsDatepicker"
        triggers=""
        [bsConfig]="bsConfig"
        [bsValue]="relativeStorage.get()"
        [isDisabled]="isReadOnly"
        (bsValueChange)="_onDatePickerChange($event)"
        (onHidden)="_onDatePickerHidden()"
        type="text"
        class="form-control date-input text-right"
        [class.is-warning]="relativeStorage.shouldShowWarning()"
        [class.is-invalid]="relativeStorage.shouldShowError()"
        [class.is-readonly]="isReadOnly"
        [name]="path"
        [minDate]="minDate"
        [maxDate]="maxDate"
        [placeholder]="placeholder"
        [readonly]="isReadOnly"
        autocomplete="off"
        (focus)="_onFocus($event)"
        (blur)="_onBlur($event, false)"
      />

      <!-- Date icon -->
      <div class="input-group-append" (click)="dp.toggle()">
        <div class="input-group-text"><lf-icon icon="calendar"></lf-icon></div>
      </div>
    </div>

    <!-- Legend -->
    <div *ngIf="legend" class="legend">{{ legend }}</div>
  </ng-container>
</ng-container>
